import React from 'react';

const AcademicPerformanceTable = ({ columns = [], columnGroups = [], entries = [], primaryColor = '#1e3a8a' }) => {
  // Resolve Cell Value — returns ONLY real data, '—' for anything missing
  const resolveValue = (row, dataSource) => {
    if (!row || !dataSource) return '—';
    const cleanSource = dataSource.replace('academic.', '').replace('assessment.', '').replace('result.', '').replace('calculated.', '');
    let val = null;
    switch (cleanSource) {
      case 'subjectName':
      case 'name':
      case 'subject.name':
        val = row.subjectName || row.name;
        break;
      case 'subjectCode':
      case 'code':
      case 'subject.code':
        val = row.subjectCode || row.code;
        break;
      case 'fa1':
      case 'fa-1':
      case 'fa 1':
        val = row.fa1 !== undefined ? row.fa1 : (row.examMarks ? row.examMarks['FA-1'] || row.examMarks['FA1'] : null);
        break;
      case 'fa2':
      case 'fa-2':
      case 'fa 2':
        val = row.fa2 !== undefined ? row.fa2 : (row.examMarks ? row.examMarks['FA-2'] || row.examMarks['FA2'] : null);
        break;
      case 'sa1':
      case 'sa-1':
      case 'sa 1':
        val = row.sa1 !== undefined ? row.sa1 : (row.examMarks ? row.examMarks['SA-1'] || row.examMarks['SA1'] : null);
        break;
      case 'fa3':
      case 'fa-3':
      case 'fa 3':
        val = row.fa3 !== undefined ? row.fa3 : (row.examMarks ? row.examMarks['FA-3'] || row.examMarks['FA3'] : null);
        break;
      case 'fa4':
      case 'fa-4':
      case 'fa 4':
        val = row.fa4 !== undefined ? row.fa4 : (row.examMarks ? row.examMarks['FA-4'] || row.examMarks['FA4'] : null);
        break;
      case 'sa2':
      case 'sa-2':
      case 'sa 2':
        val = row.sa2 !== undefined ? row.sa2 : (row.examMarks ? row.examMarks['SA-2'] || row.examMarks['SA2'] : null);
        break;
      case 'periodicTest':
      case 'periodictest':
      case 'pt':
      case 'pt-1':
      case 't1_pt':
        val = row.periodicTest !== undefined && row.periodicTest !== null ? row.periodicTest : (row.fa1 !== undefined ? row.fa1 : (row.examMarks ? row.examMarks['PT-1'] || row.examMarks['FA-1'] || row.examMarks['FA1'] : null));
        break;
      case 't2_pt':
      case 'pt-2':
        val = row.fa2 !== undefined ? row.fa2 : (row.periodicTest !== undefined ? row.periodicTest : (row.examMarks ? row.examMarks['PT-2'] || row.examMarks['FA-2'] || row.examMarks['FA2'] : null));
        break;
      case 'notebook':
      case 'nb':
      case 't1_nb':
      case 't2_nb':
        val = row.notebook !== undefined && row.notebook !== null ? row.notebook : (row.examMarks ? row.examMarks['NB'] || row.examMarks['Notebook'] : null);
        break;
      case 'subjectEnrichment':
      case 'subjectenrichment':
      case 'sea':
      case 't1_sea':
      case 't2_sea':
        val = row.subjectEnrichment !== undefined && row.subjectEnrichment !== null ? row.subjectEnrichment : (row.examMarks ? row.examMarks['SEA'] || row.examMarks['Subject Enrichment'] : null);
        break;
      case 'halfYearly':
      case 'term1Total':
      case 'monthlyEval':
      case 't1_hy':
        val = row.halfYearly !== undefined && row.halfYearly !== null ? row.halfYearly : (row.sa1 !== undefined ? row.sa1 : (row.fa1 !== undefined ? row.fa1 : (row.examMarks ? row.examMarks['Half Yearly'] || row.examMarks['Mid Term'] || row.examMarks['SA-1'] || row.examMarks['SA1'] : null)));
        break;
      case 'yearly':
      case 'yearlyEval':
      case 'term2Total':
      case 'annualTotal':
      case 't2_ye':
        val = row.yearly !== undefined && row.yearly !== null ? row.yearly : (row.sa2 !== undefined ? row.sa2 : (row.examMarks ? row.examMarks['Final Exam'] || row.examMarks['Annual'] || row.examMarks['SA-2'] || row.examMarks['SA2'] : null));
        break;
      case 't1_tot':
        val = (row.fa1 !== undefined || row.sa1 !== undefined) ? ((row.fa1 || 0) + (row.sa1 || 0)) : (row.obtainedMarks !== undefined ? Math.round(row.obtainedMarks / 2) : null);
        break;
      case 't2_tot':
        val = (row.fa2 !== undefined || row.sa2 !== undefined) ? ((row.fa2 || 0) + (row.sa2 || 0)) : row.obtainedMarks;
        break;
      case 'theoryMarks': val = row.theoryMarks; break;
      case 'writtenMarks': val = row.writtenMarks !== undefined && row.writtenMarks !== null ? row.writtenMarks : row.theoryMarks; break;
      case 'practicalMarks': val = row.practicalMarks; break;
      case 'internalMarks': val = row.internalMarks; break;
      case 'oralMarks': val = row.oralMarks; break;
      case 'obtainedMarks':
      case 'grandTotal':
      case 'total':
        val = row.obtainedMarks;
        break;
      case 'maxMarks': val = row.maxMarks; break;
      case 'percentage':
        val = (row.maxMarks && row.obtainedMarks !== undefined && row.obtainedMarks !== null)
          ? ((row.obtainedMarks / row.maxMarks) * 100).toFixed(1) + '%'
          : null;
        break;
      case 'grade': val = row.grade; break;
      case 'credits': val = row.credits; break;
      default:
        val = row[dataSource] || row[cleanSource];
        if ((val === null || val === undefined || val === '') && row.examMarks && typeof row.examMarks === 'object') {
          if (row.examMarks[cleanSource] !== undefined) {
            val = row.examMarks[cleanSource];
          } else if (row.examMarks[dataSource] !== undefined) {
            val = row.examMarks[dataSource];
          } else {
            const cleanNorm = cleanSource.toLowerCase().replace(/[^a-z0-9]/g, '');
            for (const [k, v] of Object.entries(row.examMarks)) {
              if (k.toLowerCase().replace(/[^a-z0-9]/g, '') === cleanNorm) {
                val = v;
                break;
              }
            }
          }
        }
        break;
    }
    return (val !== null && val !== undefined && val !== '' && !Number.isNaN(val)) ? val : '—';
  };

  // Single Level Table Layout — dynamically adapt to actual exams present in entries
  const activeCols = React.useMemo(() => {
    let baseCols = (columns && columns.length > 0) ? [...columns] : [
      { key: 'subjectName', label: 'Subject Title', dataSource: 'subject.name', width: '35%', alignment: 'left' },
      { key: 'maxMarks', label: 'Max Marks', dataSource: 'result.maxMarks', width: '15%', alignment: 'center' },
      { key: 'obtainedMarks', label: 'Obtained', dataSource: 'result.obtainedMarks', width: '15%', alignment: 'center' },
      { key: 'percentage', label: 'Percentage', dataSource: 'calculated.percentage', width: '15%', alignment: 'center' },
      { key: 'grade', label: 'Grade', dataSource: 'calculated.grade', width: '20%', alignment: 'center' }
    ];

    const safeEntries = entries || [];

    // Check which standard exams have actual marks in entries
    const examColsToCheck = [
      { key: 'fa1', label: 'FA1', dataSource: 'assessment.fa1', check: e => (e.fa1 !== null && e.fa1 !== undefined && e.fa1 !== '') || (e.examMarks && (e.examMarks['FA-1'] !== undefined || e.examMarks['FA1'] !== undefined)) },
      { key: 'fa2', label: 'FA2', dataSource: 'assessment.fa2', check: e => (e.fa2 !== null && e.fa2 !== undefined && e.fa2 !== '') || (e.examMarks && (e.examMarks['FA-2'] !== undefined || e.examMarks['FA2'] !== undefined)) },
      { key: 'sa1', label: 'SA1', dataSource: 'assessment.sa1', check: e => (e.sa1 !== null && e.sa1 !== undefined && e.sa1 !== '') || (e.examMarks && (e.examMarks['SA-1'] !== undefined || e.examMarks['SA1'] !== undefined)) },
      { key: 'fa3', label: 'FA3', dataSource: 'assessment.fa3', check: e => (e.fa3 !== null && e.fa3 !== undefined && e.fa3 !== '') || (e.examMarks && (e.examMarks['FA-3'] !== undefined || e.examMarks['FA3'] !== undefined)) },
      { key: 'fa4', label: 'FA4', dataSource: 'assessment.fa4', check: e => (e.fa4 !== null && e.fa4 !== undefined && e.fa4 !== '') || (e.examMarks && (e.examMarks['FA-4'] !== undefined || e.examMarks['FA4'] !== undefined)) },
      { key: 'sa2', label: 'SA2', dataSource: 'assessment.sa2', check: e => (e.sa2 !== null && e.sa2 !== undefined && e.sa2 !== '') || (e.examMarks && (e.examMarks['SA-2'] !== undefined || e.examMarks['SA2'] !== undefined)) }
    ];

    // Check for custom exam keys in entry.examMarks
    const customExamKeys = new Set();
    safeEntries.forEach(e => {
      if (e.examMarks && typeof e.examMarks === 'object') {
        Object.keys(e.examMarks).forEach(k => {
          const norm = k.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (!['fa1', 'fa2', 'fa3', 'fa4', 'sa1', 'sa2'].includes(norm)) {
            customExamKeys.add(k);
          }
        });
      }
    });

    const examsWithData = examColsToCheck.filter(item => safeEntries.some(item.check));
    const totalExamTypesCount = examsWithData.length + customExamKeys.size;
    const hasObtainedCol = baseCols.some(c => c.key === 'obtainedMarks' || c.key === 'total' || (c.dataSource && (c.dataSource.includes('obtainedMarks') || c.dataSource.includes('total'))));

    // Only inject breakdown exam columns when MULTIPLE exams exist (e.g. FA1 + SA1).
    // If only 1 exam exists (e.g. SA1), 'Obtained' column already holds this score, so avoid duplicate columns!
    if (totalExamTypesCount > 1) {
      examsWithData.forEach(item => {
        const exists = baseCols.some(c => c.key === item.key || (c.dataSource && c.dataSource.includes(item.key)));
        if (!exists) {
          const totalIdx = baseCols.findIndex(c => c.key === 'obtainedMarks' || c.key === 'total' || (c.dataSource && c.dataSource.includes('obtainedMarks')));
          const insertAt = totalIdx !== -1 ? totalIdx : baseCols.length - 1;
          baseCols.splice(insertAt, 0, {
            key: item.key,
            label: item.label,
            dataSource: item.dataSource,
            visible: true,
            alignment: 'center'
          });
        }
      });

      customExamKeys.forEach(examTitle => {
        const exists = baseCols.some(c => (c.label && c.label.toLowerCase() === examTitle.toLowerCase()) || (c.examMapping && c.examMapping.toLowerCase() === examTitle.toLowerCase()));
        if (!exists) {
          const totalIdx = baseCols.findIndex(c => c.key === 'obtainedMarks' || c.key === 'total' || (c.dataSource && c.dataSource.includes('obtainedMarks')));
          const insertAt = totalIdx !== -1 ? totalIdx : baseCols.length - 1;
          baseCols.splice(insertAt, 0, {
            key: `exam_${examTitle.replace(/[^a-zA-Z0-9]/g, '_')}`,
            label: examTitle,
            dataSource: `assessment.${examTitle}`,
            visible: true,
            alignment: 'center'
          });
        }
      });
    } else if (totalExamTypesCount <= 1 && hasObtainedCol) {
      // If only 1 exam exists and Obtained column is present, strip any duplicate exam-specific column
      baseCols = baseCols.filter(col => {
        const isExamCol = ['fa1', 'fa2', 'fa3', 'fa4', 'sa1', 'sa2'].includes(col.key)
          || (col.dataSource && /assessment\.(fa1|fa2|fa3|fa4|sa1|sa2)/i.test(col.dataSource));
        return !isExamCol;
      });
    }

    // Filter out assessment breakdown columns that have zero data in ALL entries
    // (e.g. if FA2 or SA1 was not conducted, avoid showing empty dummy columns with '—')
    const finalCols = baseCols.filter(col => {
      const isCoreCol = ['subjectName', 'name', 'obtainedMarks', 'maxMarks', 'total', 'percentage', 'grade', 'remarks', 'credits'].includes(col.key)
        || (col.dataSource && ['subject.name', 'result.obtainedMarks', 'assessment.maxMarks', 'calculated.percentage', 'calculated.grade'].includes(col.dataSource));
      if (isCoreCol) return true;

      return safeEntries.some(row => {
        const val = resolveValue(row, col.dataSource || col.source || col.key);
        return val !== '—' && val !== null && val !== undefined && val !== '';
      });
    });

    // Clean up labels: remove hardcoded numbers in parenthesis like "(80)" or "(20)" that contradict actual marks
    return (finalCols.length > 0 ? finalCols : baseCols).map(col => {
      let label = col.label;
      if (label) {
        if (col.key === 'obtainedMarks' && label.includes('(')) {
          label = 'Obtained';
        } else {
          const match = label.match(/^(.*?)\s*\(\d+\)$/);
          if (match) {
            label = match[1].trim();
          }
        }
      }
      return { ...col, label };
    });
  }, [columns, entries]);

  // No mock entries — show empty state if no real data
  if (!entries || entries.length === 0) {
    return (
      <div style={{ marginBottom: '18px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '12px' }}>
        No academic entries available.
      </div>
    );
  }

  // Grouped Header Layout
  if (columnGroups && columnGroups.length > 0) {
    return (
      <div style={{ marginBottom: '18px', overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '1px solid #cbd5e1' }}>
          <thead>
            <tr style={{ background: primaryColor, color: '#ffffff' }}>
              <th rowSpan={2} style={{ padding: '8px 10px', textAlign: 'left', fontWeight: '700', borderRight: '1px solid rgba(255,255,255,0.2)' }}>
                Subject
              </th>
              {columnGroups.map((grp, gIdx) => (
                <th key={gIdx} colSpan={grp.columns?.length || 1} style={{ padding: '6px 10px', textAlign: 'center', fontWeight: '700', borderRight: '1px solid rgba(255,255,255,0.2)', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                  {grp.label || grp.groupName}
                </th>
              ))}
            </tr>
            <tr style={{ background: primaryColor, color: '#ffffff' }}>
              {columnGroups.flatMap(grp => grp.columns || []).map((col, cIdx) => (
                <th key={cIdx} style={{ padding: '6px 8px', textAlign: col.alignment || 'center', fontWeight: '600', fontSize: '10px', borderRight: '1px solid rgba(255,255,255,0.2)' }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {entries.map((row, idx) => (
              <tr key={idx} style={{ background: idx % 2 === 0 ? '#ffffff' : '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <td style={{ padding: '8px 10px', fontWeight: '600', borderRight: '1px solid #e2e8f0' }}>
                  {row.subjectName || row.name || '—'}
                </td>
                {columnGroups.flatMap(grp => grp.columns || []).map((col, cIdx) => (
                  <td key={cIdx} style={{ padding: '8px 8px', textAlign: col.alignment || 'center', borderRight: '1px solid #e2e8f0' }}>
                    {resolveValue(row, col.dataSource || col.source)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '18px', overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '1px solid #cbd5e1' }}>
        <thead>
          <tr style={{ background: primaryColor, color: '#ffffff' }}>
            {activeCols.map((col, idx) => (
              <th key={idx} style={{ padding: '8px 10px', width: col.width || 'auto', textAlign: col.alignment || 'left', fontWeight: '700', borderRight: '1px solid rgba(255,255,255,0.2)' }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {entries.map((row, idx) => (
            <tr key={idx} style={{ background: idx % 2 === 0 ? '#ffffff' : '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              {activeCols.map((col, cIdx) => (
                <td key={cIdx} style={{ padding: '8px 10px', textAlign: col.alignment || 'left', fontWeight: col.key === 'subjectName' ? '600' : '500', borderRight: '1px solid #e2e8f0' }}>
                  {resolveValue(row, col.dataSource || col.source)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AcademicPerformanceTable;
